import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { lock, unlock } from 'tua-body-scroll-lock';
import { formatMintues } from '../../../common/utils/formatMinutes';
import { BrandSitesV2Theme } from '../../BrandSitesV2/common/GlobalStyle';
import Portal from '../../Portal';
import CloseSvg from '../../svgs/CloseSvg';
import router from 'next/router';

interface Props {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
}

export default function OfficeInquireAskResultModal({ visible, setVisible }: Props) {
  // 모달이 떠있을 때에 스크롤 방지
  useEffect(() => {
    if (visible) lock(null);
    else unlock(null);

    return unlock;
  }, [visible]);

  if (!visible) return null;

  return (
    <>
      <Portal>
        <Dim />
        <Container>
          <CloseIcon onClick={() => setVisible(false)}>{CloseSvg}</CloseIcon>
          <Title>{'사무실 견적 상담 신청이\n완료되었습니다.'}</Title>
          <Desccription>영업일 기준 1~2일 내로 상담 연락드리겠습니다.</Desccription>
          <Button
            style={{ width: '100%' }}
            onClick={() => {
              setVisible(false);
              router.push('/office_clean');
              // TODO 팝업 닫으면 어케할지...?
            }}
          >
            확인
          </Button>
        </Container>
      </Portal>
    </>
  );
}

const Dim = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: ${BrandSitesV2Theme.brandSitesV2.headerZIndex};
`;

const Container = styled.div`
  position: fixed;
  bottom: 50%;
  left: 50%;
  background: #ffffff;
  animation: none;
  border-radius: 16px;
  transform: translate(-50%, 50%);
  padding: 68px 24px 24px 24px;
  width: 415px;
  z-index: ${BrandSitesV2Theme.brandSitesV2.headerZIndex};

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    /* bottom: 0;
    left: 50%;
    transform: translate(-50%, 0); */
    /* width: 100%; */
    /* background: #ffffff; */
    /* border-radius: 16px 16px 0px 0px; */
    /* padding: 54px 24px; */
    max-width: calc(100% - 32px);
    /* animation: slidein 0.2s; */
  }

  /* @keyframes slidein {
    from {
      transfrom: translate(-50%, 100vh);
    }

    to {
      transfrom: translate(-50%, 0);
    }
  } */
`;

const CloseIcon = styled.div`
  position: absolute;
  cursor: pointer;
  top: 22px;
  right: 24px;
`;

const Title = styled.p`
  font-size: 25px;
  font-weight: 700;
  line-height: 140%;
  color: #000000d9;
  margin-bottom: 8px;
  text-align: center;
  white-space: pre-line;
`;

const Desccription = styled.p`
  font-size: 17px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  color: #666666;
  margin-bottom: 20px;
`;

const Button = styled.button`
  padding: 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 17px;
  line-height: 140%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  border: none;
  font-family: inherit;
  background: #00bed6;
  color: #ffffff;
  transition: 0.2s;
  user-select: none;

  &:disabled {
    background: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.2);
  }

  &:not(:disabled):hover {
    background: #19c4da;
  }
`;
